import { MAX_SUB_NUMBER_LENGTH } from "../constants"
import type { GlAccountFormValues } from "../schemas/glAccountForm"

import type { GlAccount } from "@/graphql/codegen/graphql"
import { GlAccountCurrency, ReportingAccountType } from "@/graphql/codegen/graphql"

const getReportingAccountType = (account?: GlAccount | null): ReportingAccountType | undefined => {
  if (!account) return undefined
  return account.parentGlAccountId ? ReportingAccountType.Posting : ReportingAccountType.Parent
}

export const toGlAccountFormValues = (account?: GlAccount | null): Partial<GlAccountFormValues> => ({
  reportingAccountType: getReportingAccountType(account),
  parentGlAccountId: account?.parentGlAccountId || undefined,
  company: account?.companyName || "Akrochem",
  costCenter: account?.costCenter ?? null,
  number: account?.number,
  subNumber:
    account?.subNumber !== null && account?.subNumber !== undefined
      ? String(account.subNumber).padStart(MAX_SUB_NUMBER_LENGTH, "0")
      : "",
  title: account?.title || "",
  description: account?.description || "",
  type: account?.type || null,
  subType: account?.subType || null,
  classification: account?.classification || null,
  currency: account?.currency || GlAccountCurrency.Usd,
  balance: account?.balance || undefined,
})
